/**
 * Mixin to handle membership-based voucher type filtering and redemption logic.
 *
 * @mixin
 * @requires currentUser - Must be provided via context
 * @requires currentCircuit - Must be provided via configuration
 *
 * Features:
 * - Filters voucher types based on membership restrictions
 * - Handles inclusion/exclusion rules for membership types
 * - Validates redemption eligibility
 */
export default {
  context: ['currentUser'],
  configuration: ['currentCircuit'],
  computed: {
    /**
     * Filters and returns voucher types that are redeemable by the current user
     * based on their membership status and restrictions.
     *
     * @returns {Array} Array of voucher types available for redemption
     */
    membershipVoucherTypes () {
      return _.filter(this.currentCircuit.configuration.voucherTypes.data, voucherType => {
        if (!voucherType.isRedeemableForRewards()) return false

        if (!voucherType.membershipTypeRestrictionsEnabled) {
          return true
        }

        if (!this.currentUser.effectiveMembershipType) return

        const userMembershipId = this.currentUser.effectiveMembershipType?.id
        const isInMembershipList = _.includes(voucherType.membershipTypeIds, userMembershipId)

        return voucherType.membershipTypeRestrictionsExclude ? !isInMembershipList : isInMembershipList
      })
    }
  }
}
